import React from 'react';
import Loadable from 'react-loadable';

import { DefaultLayout } from './containers/DefaultLayout';

function Loading() {
  return <div>Loading...</div>;
}

const Dashboard = Loadable({
  loader: () => import('./views/Dashboard'),
  loading: Loading
});

const ClientsContainer = Loadable({
  loader: () => import('./views/Clients/Container'),
  loading: Loading
});

const GSTContainer = Loadable({
  loader: () => import('./views/Gst/Container'),
  loading: Loading
});

const BillingContainer = Loadable({
  loader: () => import('./views/Billing/Container'),
  loading: Loading
});

const ServiceContainer = Loadable({
  loader: () => import('./views/Service/Container'),
  loading: Loading
});



const ChangePassword = Loadable({
  loader: () => import('./views/User/ChangePassword'),
  loading: Loading
});


// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: '/', name: 'Home', component: DefaultLayout },
  { path: '/dashboard', name: 'Dashboard', component: Dashboard },
  { path: '/clients', name: 'Clients', component: ClientsContainer },
  { path: '/gst', name: 'GST', component: GSTContainer },
  { path: '/billing', name: 'Billing', component: BillingContainer },
  { path: '/services', name: 'Services', component: ServiceContainer },
  { path: '/changePassword', name: 'Change Password', component: ChangePassword }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js